import { createClient } from "@supabase/supabase-js";

const partnerSupabaseUrl = import.meta.env.VITE_PARTNER_SUPABASE_URL as string;
const partnerSupabaseKey = import.meta.env.VITE_PARTNER_SUPABASE_KEY as string;

if (!partnerSupabaseUrl || !partnerSupabaseKey) {
	console.error("Partner Supabase credentials not configured");
}

export const partnerSupabase = createClient(
	partnerSupabaseUrl,
	partnerSupabaseKey,
);
